import React from 'react';

import { ICardsGrid } from '../../../types/ICardsGrid';
import { IItem } from '../../../types/IItem';

import DocumentPinsCard from '../../../../ui/card/documentPinsCard/documentPinsCard';
import ComponentLoader from '../../../../ui/loaders/componentLoader/componentLoader';

import './cardsGrid.scss';

const CardsGrid: React.FC<ICardsGrid> = ({ pins, loading }) => {
  return (
    <section className={'cards-grid-wrapper'}>{loading ? <ComponentLoader /> : pins.map((item: IItem) =>
      <DocumentPinsCard key={item.assignId} item={item} />)}</section>
  );
};

export default CardsGrid;
